import { createSelector } from '@reduxjs/toolkit';
import selectCurrentCartPageActions from './selectCurrentCartPageActions';

const selectFailedAddToCurrentCartActionIds = createSelector(
  [selectCurrentCartPageActions],
  (currentCartPageActions) =>
    currentCartPageActions.addToCurrentCart.failed.map((action) => action.requestedActionId)
);

export default selectFailedAddToCurrentCartActionIds;
